/**
 * 지도 기본 좌표 (판교).
 * maps, location, store-details 등에서 공통 사용.
 */
export const DEFAULT_MAP_LAT = 37.3595704;
export const DEFAULT_MAP_LNG = 127.105399;
